import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import {Api} from "../utils/endpoint";

Vue.use(Vuex);
/* eslint-disable */


export default new Vuex.Store({
    state: {
        token: localStorage.getItem("startup_website_access_token") || null,
        userInfo: JSON.parse(localStorage.getItem("startup_website_userInfo")) || null,
        redirectPathLink: JSON.parse(localStorage.getItem("redirectPathLink")) || null,
    },
    mutations: {
        retrieveToken(state, data) {
            state.token = data.data.token;
            state.userInfo = data.data.data;
        },
        storeRedirectPath(state, data) {
            state.redirectPathLink = data;
        },
        destroyToken(state) {
            state.token = null;
            state.userInfo = null;
            state.socketInfo = null;
        }
    },
    getters: {
        loggedIn(state) {
            return state.token !== null;
        }
    },
    actions: {
        destroyToken(context) {
            if (context.getters.loggedIn) {
                return new Promise(resolve => {
                    localStorage.removeItem("startup_website_access_token");
                    localStorage.removeItem("startup_website_userInfo");
                    localStorage.removeItem("redirectPathLink");
                    context.commit("destroyToken");
                    resolve({
                        success: true
                    });
                });
            }
        },
        storeRedirectPath(context, data) {
            return new Promise((resolve, reject) => {
                localStorage.setItem(
                    "redirectPathLink",
                    JSON.stringify(data)
                );
                resolve(context.commit("storeRedirectPath", data));
            });
        },
        retrieveToken(context, credentials) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        `${Api.BASE_URL}/login-partner`, {
                            email: credentials.email,
                            password: credentials.password
                        }
                    )
                    .then(res => {
                        const token = res.data.token;
                        localStorage.setItem("startup_website_access_token", token);

                        localStorage.setItem(
                            "startup_website_userInfo",
                            JSON.stringify(res.data.data)
                        );
                        context.commit("retrieveToken", {
                            data: res.data,
                        });

                        resolve(res.data.data);
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
    },
    modules: {}
});
